export interface Container {
  id: string
  name: string
  image: string
  labels: { [name: string]: string } | null
}

export interface InfraClientResponse {
  active: Client[]
  inactive: Client[]
  idle: Client[]
}

export enum ClientAuthType {
  SECRET = 'SECRET',
  CERTIFICATE = 'CERTIFICATE'
}

export enum ClientState {
  Active = 'ACTIVE',
  Idle = 'IDLE',
  Revoked = 'REVOKED',
  Invited = 'INVITED',
  Inactive = 'INACTIVE'
}

export enum ClientStatus {
  HEALTHY = 'HEALTHY',
  IMPAIRED = 'IMPAIRED',
  UNHEALTHY = 'UNHEALTHY'
}

export interface ValidationAttackResult {
  attack_type: string
  status: 'SUCCESS' | 'ERROR'
  targeting: 'HOST' | 'CONTAINER'
  raw_errors: string[]
}
export interface ValidationResults {
  timestamp: number
  client_version: string
  client_status: ClientStatus
  results: ValidationAttackResult[]
}

export interface Client {
  containers?: Container[]
  service?: string
  gremlin_client_version?: string
  container_hash?: number
  tags?: { [key: string]: string }
  auth_type?: ClientAuthType
  os_type?: string
  os_name?: string
  os_version?: string
  docker_version?: string
  kubernetes_version?: string
  metrics_enabled?: boolean
  proxied?: boolean
  instance_start_time?: string
  service_or_default?: string
  id?: string
  labels?: { [key: string]: string }
  state?: ClientState
  active?: boolean
  revoked_by?: string
  revoked?: boolean
  idle?: boolean
  identifier?: string
  attributes?: { [key: string]: any }
  org_id?: string
  last_seen?: Date
  last_active_emitted?: Date
  created_at?: Date
  updated_at?: Date
  validation_results?: ValidationResults
  process_collection_enabled?: boolean
}
